<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="12">
        <v-datetime-picker :disabled="disabled" hint="MM/DD/YYYY format" v-model="date" dateFormat="MM/dd/yyyy" timeFormat="HH:mm:ss" :label="getPickerName()" @input="menu1 = false"> </v-datetime-picker>
        <!-- <p>
          Date in ISO format:
          <strong>{{ date }}</strong>
        </p> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from 'vue'
import DatetimePicker from 'vuetify-datetime-picker'
Vue.use(DatetimePicker)

export default {
  name: 'DateTimePicker',
  props: {
    pickerData: { date: null, name: 'OrderDate', field: null },
    disabled: null
  },
  data: vm => ({
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
    menu2: false
  }),

  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    }
  },

  watch: {
    pickerData: {
      immediate: true,
      handler (newVal, oldVal) {
        if (this.pickerData.date) {
          console.log(3333)
          let parselocal = this.parseIsoLocal(this.pickerData.date)
          this.date = new Date(new Date(parselocal).getTime())
          this.dateFormatted = this.formatDate(this.date)
          console.log(this.date)
        }
      }
    },
    date (val) {
      this.dateFormatted = new Date(this.date).toLocaleDateString() +
      ' ' +
      new Date(this.date).toLocaleTimeString()
      const [day, month, year] = [this.date.getDate(), this.date.getMonth() + 1, this.date.getFullYear()]
      const [hour, min, sec] = [this.date.getHours(), this.date.getMinutes(), this.date.getSeconds()]
      let dateObj = this.pickerData
      dateObj.date = `${year}-${month}-${day} ${hour}:${min}:${sec}`
      this.$emit('clicked', dateObj)
    }
  },

  methods: {
    parseIsoLocal (s) {
      var b = s.split(/\D/)
      return new Date(b[0], b[1] - 1, b[2], b[3], b[4], b[5], ((b[6] || '') + '000').slice(0, 3))
    },
    formatDate (date) {
      console.log(date)
      if (!date) return null
      let dt = new Date(date).toLocaleDateString() +
      ' ' +
      new Date(date).toLocaleTimeString()
      const [year, month, day] = dt.split(' ')[0].split('-')
      return `${month}/${day}/${year} ${dt.split(' ')[1]}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    getPickerName () {
      console.log('Hello', this.pickerData)
      return this.pickerData.name
    }
  }
}
</script>
